	$('.carousel').carousel({
	  interval: 5000,
   	  pause: "false"
	});
	$(document).ready(function(){
$('.navbar-toggler').click(function(){
$('.navbar-toggler').toggleClass('showtoggle');
$('.navbar-collapse').toggleClass('shows');  
});	
});	
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 30) {
        $(".header_sec").addClass("fixed");
    } else {
        $(".header_sec").removeClass("fixed");
    }
});

$(document).ready(function() {
var owl = $('.bestSlr .owl-carousel');
  owl.owlCarousel({
    margin:24,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
      	margin:10,
        items: 1,
        stagePadding: 50,
      },
      400: {	
      	margin:10,	
        items: 1,
        stagePadding: 50,
      },
      576: {	
      	margin:10,	
        items: 2,
        stagePadding: 50,
      },
      768: {
      	margin:10,
        items: 2
      },         
      992: {
      	margin:20,
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.bannerSec .owl-carousel');
  owl.owlCarousel({
    margin:0,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: false,
    responsive: {
      0: {	
        items: 1
      },
      1200: {		
        items: 1
      }
    }
  });
});

$(document).ready(function() {
    $('.hdtp .owl-carousel').owlCarousel({
      items: 3,
      loop: true,
      margin: 10,
      autoWidth:true,
      autoplay: true,
      slideTransition: "linear",
      autoplayTimeout: 0,
      smartSpeed: 6000,
      fluidSpeed: true,
      autoplayTimeout:6000,
      autoplayHoverPause:true,
      responsiveClass: true,
      nav: false,
      dots: false,
      responsive: {
        0:{
            items:2,
        },
        400:{
            items:3,
        },
        600:{
            items:3,
        },
        1000:{
            items:4,
        },
        1920 : {
            items: 6
        }
      }
    })
  })


$(document).ready(function() {
var owl = $('.cateSec .owl-carousel');
  owl.owlCarousel({
    margin:24,
    autoplayHoverPause:true,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    autoplayTimeout:1000,
    responsive: {
      0: {	
      	margin:10,
        items: 1
      },
      481: {	
      	margin:10,	
        items: 2
      },
      576: {	
      	margin:10,	
        items: 3
      },
      768: {
      	margin:10,
        items: 4
      },         
      992: {
      	margin:20,
        items: 5
      },
      1200: {
        items: 6
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.cateSecMob .owl-carousel');
  owl.owlCarousel({
    margin: 0,
    loop: true,
    autoplay:true,
    slideTransition: "linear",
      autoplayTimeout: 0,
      smartSpeed: 4000,
      fluidSpeed: true,
      autoplayTimeout:4000,
      autoplayHoverPause:true,
      responsiveClass: true,
    responsive: {
      0: {	
        items: 2,
      },
      360: {	
        items: 3,
      },
      420: {	
        items: 4,
      },
      768: {
        items: 4
      },         
      992: {
        items: 5
      },
      1200: {
        items: 6
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.catatabCaro .owl-carousel');
  owl.owlCarousel({
    margin:24,
    autoplayHoverPause:true,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    autoplayTimeout:2000,
    responsive: {
      0: {	
      	margin:10,
        items: 1,
        stagePadding: 50,
      },
      481: {	
      	margin:10,	
        items: 2,
        stagePadding: 50,
      },
      576: {	
      	margin:10,	
        items: 3,
        stagePadding: 50,
      },
      768: {
      	margin:10,
        items: 4
      },         
      992: {
      	margin:20,
        items: 5
      },
      1200: {
        items: 6
      }
    }
  });
});



$(document).ready(function() {    

	$(".fldList a").click(function(event) {        

		event.preventDefault();        

		$(this).parent().addClass("actv");        

		$(this).parent().siblings().removeClass("actv");        

		var tab = $(this).attr("href");        

		$(".fldDes").not(tab).css("display", "none");    

		$(tab).fadeIn();    

		});

	});






$(document).ready(function() {
var owl = $('.expSec .owl-carousel');
  owl.owlCarousel({
    margin:65,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    stagePadding:150,
    responsive: {
      0: {	
      	margin:10,
        items: 1,
        stagePadding:20,
      },
      481: {	
      	margin:10,	
        items: 1,
        stagePadding:50,
      },
      576: {	
      	margin:10,	
        items: 1,
        stagePadding:70,
      },
      768: {
      	margin:10,
        items: 1
      },         
      992: {
      	margin:20,
        items: 2
      },
      1200: {
      	margin:24,
        items: 3
      },
      1400: {
        items: 3
      }
    }
  });
});



$(document).ready(function() {
var owl = $('.feedSec .owl-carousel');
  owl.owlCarousel({
    margin:24,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    responsive: {
      0: {	
      	margin:10,
        items: 1
      },
      481: {	
      	margin:10,	
        items: 2
      },
      576: {	
      	margin:10,	
        items: 3
      },
      768: {
      	margin:10,
        items: 3
      },         
      992: {
      	margin:20,
        items: 4
      },
      1200: {
        items: 4
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.collectncaro .owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: false,
    responsive: {
      0: {	
      	margin:10,
        items: 1
      },
      481: {	
      	margin:10,	
        items: 2
      },
      576: {	
      	margin:10,	
        items: 2
      },
      768: {
      	margin:10,
        items: 2
      },         
      992: {
      	margin:20,
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.prodctGrdCaro');
  owl.owlCarousel({
    loop: true,
      margin: 15,
      slideTransition: "linear",
      smartSpeed: 6000,
      fluidSpeed: true,
      autoplayTimeout:6000,
      autoplayHoverPause:true,
      nav: false,
      dots: false,
    autoplay:true,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    responsive: {
      0: {	
      	margin:10,
        items: 1
      },
      481: {	
      	margin:10,	
        items: 2
      },
      576: {	
      	margin:10,	
        items: 2
      },
      768: {
      	margin:10,
        items: 2
      },         
      992: {
      	margin:20,
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.logosSec .owl-carousel');
  owl.owlCarousel({
    loop: true,
      margin: 10,
      slideTransition: "linear",
      smartSpeed: 6000,
      fluidSpeed: true,
      autoplayTimeout:6000,
      autoplayHoverPause:true,
      nav: false,
      dots: false,
    autoplay:true,
    responsive: {
      0: {	
        items: 2
      },
      481: {	
        items: 2
      },
      576: {		
        items: 3
      },
      768: {
        items: 3
      },         
      992: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
  });
});
$(document).ready(function(){
$('#open').click(function(){
$('#hide').slideToggle();
$('.hdmidl').toggleClass('actv');
});
$('.closeSrch').click(function(){
$('#hide').slideToggle();
$('.hdmidl').removeClass('actv');  
});  
  
});
$(document).ready(function(){
$('.egtab').jsScroll({
    height: '300px'
});
});
$(document).ready(function() {
var owl = $('.detlsMidSec .owl-carousel');
  owl.owlCarousel({
    margin:15,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: false,
    responsive: {
      0: {	
        items: 1
      },
      481: {	
        items: 1
      },         
      992: {
        items: 2
      },
      1200: {
        items: 2
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.addOffer .owl-carousel');
  owl.owlCarousel({
    margin:15,
    dots: false,
    autoplay: true,
    nav: false,
    dotsEach: false,
    loop: true,
    stagePadding: 50,
    responsive: {
      0: {	
        items: 1
      },
      481: {	
        items: 1
      },         
      992: {
        items: 1
      },
      1300: {
        items: 2
      }
    }
  });
});

$(document).ready(function() {
var owl = $('.fitsmRw');
  owl.owlCarousel({
    margin:15,
    dots: false,
    autoplay: false,
    nav: false,
    dotsEach: false,
    loop: false,
    responsive: {
      0: {	
      	margin:10,
        items: 1,
        autoplay: true,
        loop: true,
      },
      481: {	
      	margin:10,	
        items: 2,
        autoplay: true,
        loop: true,
      },
      576: {	
      	margin:10,	
        items: 2,
        autoplay: true,
        loop: true,
      },
      768: {
      	margin:10,
        items: 2,
        autoplay: true,
        loop: true,
      },         
      992: {
      	margin:20,
        items: 3
      },
      1200: {
        items: 3
      }
    }
  });
});
 